export const SEPARATE_APPLICATION_BADGE_LABEL = 'Separate Application';
